import Dexie from "dexie";
const OPERATION_DB_NAME = "operationLocalStorageDb";
const db = new Dexie(OPERATION_DB_NAME);

export const TABLE_NAMES = {
  OPERATIONS: "operations",
  OPERATION_WORKFLOWS: "operation_workflows",
  OPERATION_COLUMNS: "operation_columns",
  OPERATION_VESSELS: "operation_vessels",
  OPERATION_ACCOUNTS: "operation_accounts",
  ENTERPRISE_WORKFLOWS: "enterprise_workflows",
  ENTERPRISE_FORMS: "enterprise_forms",
};

export default {
  init() {
    db.version(1).stores({
      [TABLE_NAMES.OPERATIONS]: "id, sort_order, service, download_available",
      [TABLE_NAMES.OPERATION_WORKFLOWS]: `
        id,
        ao_enterprise_id,
        ao_enterprise_workflow_vessels,
        ao_enterprise_workflow_transactions,
        ao_enterprise_workflow_statuses,
        ao_enterprise_workflow_forms,
        created_at,
        updated_at`,
      [TABLE_NAMES.OPERATION_COLUMNS]:
        "id, name, ao_enterprise_id, ao_enterprise_column_form_version_items",
      [TABLE_NAMES.OPERATION_VESSELS]:
        "id, disabled_at, permission_level, sort_order, vessel",
      [TABLE_NAMES.OPERATION_ACCOUNTS]:
        "enterprise_account_id, account, profile, created_at, updated_at, deleted_at, free",
      [TABLE_NAMES.ENTERPRISE_WORKFLOWS]:
        "id, workflow_statuses, workflow_transactions",
      [TABLE_NAMES.ENTERPRISE_FORMS]: "id, form_versions",
    });
  },

  getInstance() {
    return db;
  },

  isExists() {
    return Dexie.exists(OPERATION_DB_NAME);
  },
};
